// SearchResultsPage.js
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import '../css/SearchResultsPage.css'; // reuse styles
import { useNavigate } from 'react-router-dom';

function SearchResultsPage() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const searchTerm = queryParams.get('query')?.toLowerCase() || '';

    const [products, setProducts] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProducts = async () => {
            const productsRef = collection(db, "products");
            const snapshot = await getDocs(productsRef);
            const productList = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setProducts(productList);
        };
        fetchProducts();
    }, []);

    useEffect(() => {
        const results = products.filter(
            product =>
                product.title.toLowerCase().includes(searchTerm) ||
                product.description?.toLowerCase().includes(searchTerm) ||
                product.category?.toLowerCase().includes(searchTerm)
        );
        setFiltered(results);
    }, [searchTerm, products]);

    const handleShopNow = (id) => {
        // Navigate to the detail page for the product with the specified id.
        navigate(`/detail/${id}`);
    };

    return (
        <div className="products-page">
            <div className="products-header">
                <h1>Search Results</h1>
                <p>{filtered.length} results found for "{searchTerm}"</p>
            </div>

            <div className="products-grid">
                {filtered.map((item) => (
                    <div className="product-card" key={item.id}>
                        <div className="product-img-container">
                            <img src={item.image} alt={item.title} className="product-img" />
                        </div>
                        <div className="product-details">
                            <p className="product-name">{item.title}</p>
                            <p className="product-price">Rs.{item.price?.toLocaleString('en-LK')}</p>
                            <button
                                className="shop-button"
                                onClick={() => handleShopNow(item.id)}
                            >
                                Shop Now
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SearchResultsPage;
